import React, { useCallback } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { CellRendererRoot } from '.'
import { Checkbox } from '../../../../../components/inputs/Checkbox'
import { CopyRoot } from '../../../model'
import { ProjectPlanSelectRow } from '../model'

type CheckboxCellRendererProps = ICellRendererParams<
  ProjectPlanSelectRow,
  boolean
> & {
  projectUuid: string | undefined
  updateSelected: (uuid: CopyRoot, selected: boolean) => void
}

export const CheckboxCellRenderer = ({
  value,
  data,
  projectUuid,
  updateSelected,
}: CheckboxCellRendererProps) => {
  const onChange = useCallback(
    (_, value: boolean) => {
      if (!data) return
      if (!value) return
      if (data.uuid === projectUuid) {
        updateSelected(
          {
            type: 'PROJECT',
          },
          value
        )
        return
      }
      updateSelected(
        {
          type: 'WBS',
          uuid: data.uuid,
          name: data.displayName,
        },
        value
      )
    },
    [data, projectUuid, updateSelected]
  )
  return (
    <CellRendererRoot>
      <Checkbox checked={value ?? undefined} onChange={onChange} />
    </CellRendererRoot>
  )
}
